import { render, staticRenderFns } from "./popupSelectObservationsReport.vue?vue&type=template&id=32bb58d8&scoped=true"
import script from "./popupSelectObservationsReport.vue?vue&type=script&lang=js"
export * from "./popupSelectObservationsReport.vue?vue&type=script&lang=js"
import style0 from "./popupSelectObservationsReport.vue?vue&type=style&index=0&id=32bb58d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb58d8",
  null
  
)

export default component.exports